import { composeOrderNote } from '@theme/dew-delivery-rules';
/**
 * Mirrors the dated arrangements in the cart into the cart note, so the order's
 * Notes card in Shopify admin reads e.g. "Golden Hour · Delivery Wed, Sep 16 · By 10am".
 * The theme's own cart-note field is off (settings.show_cart_note), so the note is ours to own.
 */
const root = () => window.Shopify?.routes?.root || '/';
const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
async function sync() {
  const cart = await (await fetch(`${root()}cart.js`, { cache: 'no-store', headers })).json();
  const note = composeOrderNote(cart);
  if ((cart.note || '') !== note) await fetch(`${root()}cart/update.js`, { method: 'POST', headers, body: JSON.stringify({ note }) });
  return note;
}
let chain = Promise.resolve('');
/** Serialized so a later cart change always wins; resolves with the note that was written. */
export function syncOrderNote() {
  chain = chain.then(sync, sync).catch(() => '');
  return chain;
}
document.addEventListener('shopify:cart:lines-update', event => { (event.promise || Promise.resolve()).then(syncOrderNote, syncOrderNote); });
if (document.querySelector('tr[data-key]')) syncOrderNote();
